<template>
  <div class="navbar">
    <v-app-bar color="white" elevation="0">
      <v-toolbar-title>
        <router-link to="/">
          <v-img max-width="60px" src="../assets/logo.png"></v-img>
        </router-link>
      </v-toolbar-title>
      <div v-if="isAuthenticated" class="ml-5">
        Welcome {{ user ? user.First : "" }}
      </div>
      <v-spacer></v-spacer>
      <!-- <v-menu transition="slide-x-transition" bottom right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">
            <v-icon>mdi-apps</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <a :href="cfg.ACCOUNTS_UI_PROFILE" target="_blank">
              <v-img max-width="90px" src="../assets/PjiliAccounts.svg"></v-img>
            </a>
          </v-list-item>
          <v-list-item>
            <a :href="cfg.AUCTIONS_UI_URL" target="_blank">
              <v-img max-width="90px" src="../assets/PjiliAuctions.svg"></v-img>
            </a>
          </v-list-item>
          <v-list-item>
            <a :href="cfg.PJILI_PLUS_UI_URL" target="_blank">
              <v-img max-width="90px" src="../assets/PjiliPlus.svg"></v-img>
            </a>
          </v-list-item>
        </v-list>
      </v-menu> -->
      <!-- different website icons open menu -->
      <v-menu transition="slide-x-transition" bottom right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">
            <v-icon>mdi-apps</v-icon>
          </v-btn>
        </template>
        <v-list class="pa-0 ma-0" v-for="(item, i) in menuIcons" :key="i">
          <v-list-item class="hover-effect ma-0 pa-0">
            <a
              class="text-center grey--text text--darken-3"
              :href="item.url"
              target="_blank"
            >
              <v-img max-width="90px" :src="item.img"></v-img>
              <p>
                {{ item.name }}
              </p>
            </a>
          </v-list-item>
        </v-list>
      </v-menu>
      <div v-if="isAuthenticated">
        <v-btn color="primary" class="ml-2" link :href="cfg.LOGOUT_URL"
          >LOGOUT</v-btn
        >
      </div>
      <div v-else>
        <v-btn color="primary" class="ml-2" link :href="cfg.LOGIN_URL"
          >SIGN IN</v-btn
        >
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import cfg from "@/cfg";
export default {
  data() {
    return {
      cfg: this.$cfg,
      menuIcons: [
        {
          name: "Account",
          img: require("../assets/PjiliAccounts.svg"),
          url: cfg.ACCOUNTS_UI_PROFILE
        },
        {
          name: "Auctions",
          img: require("../assets/PjiliAuctions.svg"),
          url: cfg.AUCTIONS_UI_URL
        },
        {
          name: "Pjili plus",
          img: require("../assets/PjiliPlus.svg"),
          url: cfg.PJILI_PLUS_UI_URL
        }
      ]
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    isAuthenticated() {
      return this.$store.state.user.isAuthenticated;
    }
  }
};
</script>

<style lang="scss">
.hover-effect {
  background-color: #fff !important;
  transition: all 0.3s;
}
.hover-effect:hover {
  background-color: #eee !important;
  transition: all 0.3s;
}
</style>
